import React, { useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function FlavorShowcase() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [{
    image: 'https://cdn.magicpatterns.com/uploads/dwiSMVREuhm6zXoUM3Z5cG/hf_20260301_202654_4192a041-4166-4d36-9a9c-61c7388d41eb.jpg',
    label: 'Flan de Coco',
    salePrice: 4.2,
    costPrice: 1.2
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5MdFH3wG3qYfQHzapWnfww/hf_20260301_202701_f693580f-8102-4973-89a4-ce12c6d8e30a_(1).jpg',
    label: 'Flan Clásico',
    salePrice: 3.2,
    costPrice: 0.9
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9BayxCJfkRrRWCx1u2QaG1/hf_20260301_202651_ca5e6c18-ff4d-48a5-af89-66698b6ca40d.jpg',
    label: 'Flan de Chocolate',
    salePrice: 4.7,
    costPrice: 1.4
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8Sdt6fp6QjdkvRyY681m52/hf_20260314_193418_ba7b2619-e6dc-4fb9-8042-2f97180fa357.jpg',
    label: 'Flan de Queso',
    salePrice: 4.7,
    costPrice: 1.3
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/qwy3vG6RhyEsHgQ8jfNBfk/hf_20260314_193431_0154f1f8-c02b-4aaf-95d9-52fe9b92e2da.jpg',
    label: 'Flan de Crema',
    salePrice: 3.7,
    costPrice: 1.0
  }];
  const prev = () => setCurrentIndex(i => i === 0 ? slides.length - 1 : i - 1);
  const next = () => setCurrentIndex(i => i === slides.length - 1 ? 0 : i + 1);
  return <section className="py-8 md:py-20 px-4 bg-brown-dark text-cream border-t border-[#3D2B1F]" data-id="element-87">
      <div className="max-w-5xl mx-auto" data-id="element-88">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-caramel mb-5 md:mb-12" data-id="element-89">
          Algunos tipos de flanes que aprenderas a hacer HOY
        </h2>

        {/* Carousel */}
        <div className="relative" data-id="element-90">
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 md:-translate-x-6 z-10 bg-white/90 hover:bg-white text-brown-dark w-9 h-9 md:w-12 md:h-12 rounded-full shadow-lg flex items-center justify-center transition-all" data-id="element-91">
            <ChevronLeftIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-92" />
          </button>
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 md:translate-x-6 z-10 bg-white/90 hover:bg-white text-brown-dark w-9 h-9 md:w-12 md:h-12 rounded-full shadow-lg flex items-center justify-center transition-all" data-id="element-93">
            <ChevronRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-94" />
          </button>

          <div className="overflow-hidden rounded-xl md:rounded-2xl" data-id="element-95">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-96">
              {slides.map((slide, i) => <div key={i} className="w-full flex-shrink-0 px-1 md:px-2" data-id="element-97">
                  <div className="relative rounded-xl md:rounded-2xl overflow-hidden aspect-[16/9] max-h-[280px] md:max-h-none shadow-xl border-2 md:border-4 border-white/50" data-id="element-98">
                    <img src={slide.image} alt={slide.label} className="w-full h-full object-cover" width={800} height={450} loading="lazy" data-id="element-99" />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-4 md:p-6" data-id="element-100">
                      <p className="font-heading font-bold text-lg md:text-2xl text-white drop-shadow-lg" data-id="element-101">
                        {slide.label}
                      </p>
                      <div className="flex items-center gap-3 md:gap-4 mt-1 md:mt-2" data-id="element-102">
                        <span className="text-sm md:text-base text-green-300 font-bold drop-shadow" data-id="element-103">
                          Venta: ${slide.salePrice.toFixed(2)}
                        </span>
                        <span className="text-sm md:text-base text-white/70 font-medium drop-shadow" data-id="element-104">
                          Costo: ${slide.costPrice.toFixed(2)}
                        </span>
                        <span className="text-xs md:text-sm bg-green-500/80 text-white font-bold px-2 py-0.5 rounded-full" data-id="element-105">
                          +${(slide.salePrice - slide.costPrice).toFixed(2)}{' '}
                          ganancia
                        </span>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-4 md:mt-6" data-id="element-106">
            {slides.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-3 h-3 rounded-full transition-all ${i === currentIndex ? 'bg-caramel w-8' : 'bg-white/40 hover:bg-white/60'}`} data-id="element-107" />)}
          </div>
        </div>

        <div className="mt-4 md:mt-10 text-center" data-id="element-108">
          <p className="text-xl md:text-2xl font-bold mt-2 md:mt-4 tracking-widest text-white" data-id="element-109">
            …Y MUCHAS MÁS.
          </p>
        </div>
      </div>
    </section>;
}